import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthStore } from '../services/auth.store';

export const localAuthHttpInterceptorFn: HttpInterceptorFn = (req, next) => {
  if (environment.auth.mode !== 'local-auth') {
    return next(req);
  }

  if (!req.url.startsWith(environment.apiPath) || req.headers.has('Authorization')) {
    return next(req);
  }

  const token = inject(AuthStore).token();
  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
